import Immutable from 'immutable';


import {
	createModuleState,
	SimpleDefinitionModel,
	WizardDefinition as Wizard,
	WizardStepDefinition as Step,
	FormDefinition as Form,
	FormItemDefinition as FormItem,
	BoxDefinition as Box,
	Box as BoxComponent,
	ContextValidator,
	ContainerDefinition as Container,
	CrossDefinition as Cross,
	ValueValidator,
	isEmpty,
	CentererDefinition as Centerer,
	DefinitionUtils,
	MessageDefinition as Message,
	TabularInputDefinition as TabularInput,
	styled,
	webapi,
	REPORTED_EXCEPTION,
	showMessageBox,
	StaticLookup,
	ModuleHeader,
	FormItem as FormItemComponent,
	ModuleHeaderItem,
	RuntimeUtils,
	NumberUtils,
	DateUtils,
	Icon,
	// Error,
	updateEntityTimestamp,
	Button
} from 'ps-gui';

import { StatusBubble } from '../submissioncomponents';

import {default as PortalMessage} from '../../blocks/message';


import { getColumnText, getFormItemLabel, getPhrase } from '../../data/phrases';
import {
	compareShares,
	getRangeValidator,
	isrcInputFilter,
	parsePinDob,
	sum,
	validateISRC,
	validatePinDob,
	validateRuntime,
	// validatePin,
	// validatePinDob
} from '../utils';
import memoizeOne from 'memoize-one';
import { getLookup } from '../../data/lookup';




const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('RecordingProtocolDetail');
const EMPTY_LIST = Immutable.List([]);

export default class RecordingProtocolDetailModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}


	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new RecordingProtocolDetailModel(this.#data.setIn(name, value));
		} else {
			return new RecordingProtocolDetailModel(this.#data.set(name, value));
		}
	}

	#setInitialized() {
		return this.#setProperty('initialized', true);
	}

	setRoleId(value) {
		return this.#setProperty('roleId', value);
	}

	initialize() {
		DefinitionUtils.setLabels(wizardDefinition, 'recordingProtocol');
		let wizard = new SimpleDefinitionModel()
			.setDefinition(wizardDefinition)
			.setAsBaseState();
		return this.#setWizard(wizard).#setProperty(['wizard', 'data', 'roleId'], this.#data.get('roleId')).#setInitialized();
	}

	setAdminMode(value) {
		let model = this.#setProperty('adminMode', value);
		if (model.#data.getIn(['wizard', 'data'])) {
			model = model.#setProperty(['wizard', 'data', 'adminMode'], value);
		}
		return model;
	}

	async load(id) {
		let model = this;
		if (!model.#data.get('inititalized')) {
			model = model.initialize();
		}
		let res = await webapi.execute('/api/proc/api_myrecordings/getRecordingProtocolDetail', {
			id
		});
		if (res === REPORTED_EXCEPTION) {
			return model;
		}
		const performers = Immutable.fromJS(res.lineup?.performers || []);
		const recording = Immutable.fromJS(res.recording || {});
		const adminMode = this.#data.get('adminMode');
		model = model.#setProperty(['wizard', 'data', 'adminMode'], adminMode);
		model = model.#setProperty(['wizard', 'data', 'recording'], recording);
		model = model.#setProperty(['wizard', 'data', 'lineup', 'performers'], performers);
		model = model.#setProperty(['wizard', 'data', 'lineup', 'composers'], Immutable.fromJS(res.lineup?.composers || []));
		model = model.#setProperty(['wizard', 'data', 'lineup', 'lyricists'], Immutable.fromJS(res.lineup?.lyricists || []));
		model = model.#setProperty(['wizard', 'data', 'selectedStepId'], res.readOnly ? 'recordingProtocolSummary' : 'basicInfo');
		model = model.#setProperty(['wizard', 'data', 'readOnly'], adminMode ? true : res.readOnly);
		model = model.#setProperty(['wizard', 'data'].concat(PERFORMER_TOTAL_SHARE_PATH), sum(performers, 'sharePct'));
		model = model.#setProperty(['wizard', 'data', 'type'], res.type);
		model = model.#setProperty(['wizard', 'data', 'requestedType'], res.requestedType);
		model = model.#setProperty(['wizard', 'data', 'status'], res.status);
		model = model.#setProperty(['wizard', 'data', 'comments'], res.comments);
		model = model.#setProperty(['wizard', 'data', 'adminSameIsrc'], Immutable.fromJS(res.adminSameIsrc));

		if (res.roleId) {
			res = await webapi.execute('/api/proc/api_myrecordings/getRecordingProtocolRoleInfo', {
				roleId: res.roleId
			});
			if (res === REPORTED_EXCEPTION) {
				return model;
			}
			model = model.#setProperty(['wizard', 'data', 'roleInfo'], Immutable.fromJS(res));
		}
		model = model.#setProperty(['wizard', 'data', 'originalRecording'], recording);
		model = model.#setProperty(['wizard', 'data', 'originalLineup'], model.#data.getIn(['wizard', 'data', 'lineup']));
		return model;
	}

	#setWizard(wizard) {
		return this.#setProperty('wizard', wizard.getState());
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

const margin = '32px';
const boxPadding = '0px 8px';
const contentPadding = '12px 4px';
const headerPadding = '12px 4px';


const ProtocolTypeWrapper = styled.div`
`;

const ProtocolType = styled.div`
	padding: 16px;
	width: 100%;
	background: #FFFFFF;
	font-weight: 500;
	box-shadow: 7px 13px 80px rgba(21, 46, 67, 0.1);
	border-radius: 15px;
	margin-bottom: 32px;
	margin-top: 32px;

	a.header {
		color: ${props => props.theme.textColor};
		text-decoration: none;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
		font-size: 18px;
		margin-bottom: 8px;
		display: inline-block;
	}

	.text {
		font-size: 16px;
		color: ${props => props.theme.disabledTextColor};
	}

`;


function applyProducerCode(isrc, producerCode) {
	if (isEmpty(isrc)) {
		return 'CZ' + producerCode;
	}
	isrc = isrc.trim();
	return 'CZ' + producerCode + isrc.substring(5);
}

function processRecordingTypeChange(ctx) {
	const producerCodes = ctx.getRootProperty(['roleInfo', 'producerCodes', ctx.getRootProperty(['recording', 'recordingTypeId'])]) || EMPTY_LIST;
	ctx.setRootProperty('producerCodes', producerCodes);
	if (producerCodes.size > 0) {
		const isrc = applyProducerCode(ctx.getRootProperty(['recording', 'isrc']), producerCodes.get(0));
		ctx.setRootProperty(['recording', 'isrc'], isrc);
		return true;
	}
	return false;
}

const protocolTypeKeys = [
	{phraseId: 'createIsrcAndCatalogRecordingProtocol', code: 'IK'},
	{phraseId: 'createCatalogRecordingProtocol', code: 'K'},
	{phraseId: 'createIsrcRecordingProtocol', code: 'I'},
];

const ProducerCodes = styled.div`
	display: inline-block;
	padding: ${props => props.theme.inputPadding};
	.producerCode {
		font-weight: 500;
		color: ${props => props.theme.textColor};
		margin-right: 8px;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
`;

const ALL_ISRC_ERRORS_ARE_IGNORABLE = false;
const ISRC_ERROR_PATH = ['tmp', 'isrcErrors'];
const ISRC_WARNING_PATH = ['tmp', 'isrcWarnings'];

const IsrcWarnings = styled.div`
	.header {
		font-weight: 500;
		margin-bottom: 12px;
	}
	.protocolErrors {
		color: ${props => props.theme.errorColor};
	}
	.body {
		margin-bottom: 12px;

		.attribute {
			margin-right: 8px;
			.label {
				font-weight: 500;
				opacity: 0.7;
				margin-right: 4px;
			}
			.value {
				user-select: all;
			}
		}
	}
	.warning {
		margin-left: 16px;
		margin-bottom: 4px;
		.type {
			margin-right: 4px;
			opacity: 0.8;
			font-weight: 500;
			font-size: 90%;
		}
		.submissionDetail {
			font-size: 90%;
			margin-left: 8px;
			.label {
				font-weight: 500;
				opacity: 0.8;
				margin-right: 4px;
			}
			.value {
				font-weight: 500;
			}
			.submittedWhen {
				margin-left: 4px;
				opacity: 0.8;
				font-size: 90%;
			}
		}
	}
`;

async function processIsrcChange(ctx, isrc) {
	let pars = {
		isrc,
		id: ctx.getRootProperty(['recording', 'recordingProtocolId'])
	};
	let protocolWarnings = [];
	let catalogWarnings = [];
	let mdbWarnings = [];
	let errors = [];
	if (pars.isrc) {
		const types = ctx.getRootProperty('type') || ctx.getRootProperty('requestedType') || '';
		const isNp = types.indexOf('I') >= 0 || types.indexOf('A') >= 0;
		const isK = types.indexOf('K') >= 0;
		const res = await webapi.execute('/api/proc/api_myrecordings/getRecordingProtocolIsrcInfo', pars);
		if (res === REPORTED_EXCEPTION) {
			return;
		}
		if (isK && res.catalog) {
			catalogWarnings = res.catalog;
		}
		if (res.protocols) {
			res.protocols = res.protocols.filter(row => {
				if (row.typeId === 'K' && !isK) {
					return false;
				}
				if ((row.typeId === 'I' || row.typeId === 'A') && !isNp) {
					return false;
				}
				return true;
			});
			protocolWarnings = res.protocols.filter(row => {
				return ALL_ISRC_ERRORS_ARE_IGNORABLE || row.ignorable;
			});
			errors = res.protocols.filter(row => {
				return !ALL_ISRC_ERRORS_ARE_IGNORABLE && !row.ignorable;
			});
		}
		if (res.mdb && isNp) {
			mdbWarnings = res.mdb;
		}
	}
	if (errors.length > 0) {
		ctx.setRootProperty(ISRC_ERROR_PATH, Immutable.fromJS(errors));
	} else {
		ctx.setRootProperty(ISRC_ERROR_PATH, null);
	}
	if (catalogWarnings.length > 0 || protocolWarnings.length > 0 || mdbWarnings.length > 0) {
		ctx.setRootProperty(ISRC_WARNING_PATH, Immutable.fromJS({
			catalogWarnings,
			protocolWarnings,
			mdbWarnings
		}));
	} else {
		ctx.setRootProperty(ISRC_WARNING_PATH, null);
	}
}

function clearIsrcErrors(ctx) {
	ctx.setRootProperty(ISRC_ERROR_PATH, null);
	ctx.setRootProperty(ISRC_WARNING_PATH, null);
}

function renderDuplicateIsrcMessage(ctx) {
	const warnings = ctx.getRootProperty(ISRC_WARNING_PATH);
	const errors = ctx.getRootProperty(ISRC_ERROR_PATH);
	if (!warnings && !errors) {
		return null;
	}
	const protocolWarnings = (warnings || EMPTY_MAP).get('protocolWarnings') || EMPTY_LIST;
	const catalogWarnings = (warnings || EMPTY_MAP).get('catalogWarnings') || EMPTY_LIST;
	const mdbWarnings = (warnings || EMPTY_MAP).get('mdbWarnings') || EMPTY_LIST;
	const luType = getLookup('recordingProtocolSubmissionType');
	return (
		<PortalMessage>
			<IsrcWarnings>
				{
					errors && errors.size > 0 && (
						<div className='protocolErrors'>
							<div className='header'>{getPhrase(errors.size === 1 ? 'recordingProtocol.sameIsrcRecordingErrorHeader' : 'recordingProtocol.sameIsrcRecordingsErrorHeader')}:</div>
							<div className='body'>
								{
									errors.map((w, index) => {
										return (
											<div className='warning' key={index}>
												<span className='type'>{luType.getText(w.get('typeId'))}:</span><span className='title'>{w.get('title')}</span> {w.get('subtitle') && <span className='subtitle'>{w.get('subtitle')}</span>} <span className='submissionDetail'><span className='label'>{getFormItemLabel('submittedBy')}:</span><span className='value'>{w.get('partyName')}</span><span className='submittedWhen'>{DateUtils.formatDate(w.get('submittedWhen'))}</span></span>
											</div>
										);
									})
								}
							</div>
						</div>
					)
				}
				{
					protocolWarnings.size > 0 && (
						<div className='protocolWarnings'>
							<div className='header'>{getPhrase(protocolWarnings.size === 1 ? 'recordingProtocol.sameIsrcRecordingWarningHeader' : 'recordingProtocol.sameIsrcRecordingsWarningHeader')}:</div>
							<div className='body'>
								{
									protocolWarnings.map((w, index) => {
										return (
											<div className='warning' key={index}>
												<span className='type'>{luType.getText(w.get('typeId'))}:</span><span className='title'>{w.get('title')}</span> {w.get('subtitle') && <span className='subtitle'>{w.get('subtitle')}</span>} <span className='submissionDetail'><span className='label'>{getFormItemLabel('submittedBy')}:</span><span className='value'>{w.get('partyName')}</span><span className='submittedWhen'>{DateUtils.formatDate(w.get('submittedWhen'))}</span></span>
											</div>
										);
									})
								}
							</div>
						</div>
					)
				}
				{
					catalogWarnings.size > 0 && (
						<div className='protocolWarnings'>
							<div className='header'>{getPhrase(protocolWarnings.size === 1 ? 'catalog.sameIsrcRecordingWarningHeader' : 'catalog.sameIsrcRecordingsWarningHeader')}:</div>
							<div className='body'>
								{
									catalogWarnings.map((w, index) => {
										return (
											<div className='warning' key={index}>
												<span className='title'>{w.get('title')}</span> {w.get('subtitle') && <span className='subtitle'>{w.get('subtitle')}</span>} <span className='submissionDetail'><span className='label'>{w.get('roleType')}:</span><span className='value'>{w.get('partyName')}</span><span className='submittedWhen'>{DateUtils.formatDate(w.get('submittedWhen'))}</span></span>
											</div>
										);
									})
								}
							</div>
						</div>
					)
				}
				{
					mdbWarnings.size > 0 && (
						<div className='protocolWarnings'>
							<div className='header'>{getPhrase(mdbWarnings.size === 1 ? 'mdb.sameIsrcRecordingWarningHeader' : 'mdb.sameIsrcRecordingsWarningHeader')}:</div>
							<div className='body'>
								{
									mdbWarnings.map((w, index) => {
										return (
											<div className='warning' key={index}>
												<span className='title'>{w.get('title')}</span> {w.get('subtitle') && <span className='subtitle'>{w.get('subtitle')}</span>}
											</div>
										);
									})
								}
							</div>
						</div>
					)
				}
			</IsrcWarnings>
		</PortalMessage>
	);

}

const basicInfoFormDefinition =
	Form().setBasePath('recording').setItems([
		Box().setContent(
			Container([
				Message(ctx => {
					const statusId = ctx.getRootProperty('status');
					if (statusId !== 'RETURNED') {
						return null;
					}
					let itgComments = ctx.getRootProperty('comments');
					if (isEmpty(itgComments)) {
						return null;
					}
					return (
						<PortalMessage>{itgComments}</PortalMessage>
					);
				}),
				Cross().setItems([
					FormItem('recordingTypeId', 'lookup')
						.setLookup('recordingProtocolRecordingType')
						.setMandatory(true)
						.setWidth('calc( 25% )')
						.onChange((ctx, def, value) => {
							processRecordingTypeChange(ctx);
						}),
					Message(ctx => {
						const producerCodes = ctx.getRootProperty('producerCodes');
						if (!producerCodes || producerCodes.size <= 1) {
							return null;
						}
						return (
							<FormItemComponent label={getColumnText('producerCodes')}>
								<ProducerCodes>
									{
										producerCodes.map(pc => {
											return (
												<span
													className='producerCode'
													key={pc}
													onMouseDown={e => {
														window.setTimeout(() => {
															ctx.updateData(true);
															const isrc = applyProducerCode(ctx.getProperty('isrc'), pc);
															ctx.setProperty('isrc', isrc);
														});
													}}
												>{pc}</span>
											);
										})
									}
								</ProducerCodes>
							</FormItemComponent>
						);
					})
				]),
				Cross().setItems([
					FormItem('isrc', 'text')
						.setMaxLength(12)
						.setWidth('160px')
						.setInputFilter(isrcInputFilter)
						.onChange(async (ctx, def, value) => {
							processIsrcChange(ctx, value);
						})
						.setValidator(ValueValidator(validateISRC)),
					FormItem('producer', 'text').setMaxLength(250)
				]).setValidator(ContextValidator(((errors, ctx, itemName) => {
					if (itemName === 'isrc' || !itemName) {
						ctx.updateData(true);
						const fullPath = ctx.getFullPath('duplicateIsrc');
						const errs = ctx.getRootProperty(ISRC_ERROR_PATH);
						if (errs) {
							errors.add(fullPath, {
								type: 'error',
								code: 'unprocessedIsrcExists',
								message: getPhrase('duplicateIsrc'),
								longMessage: getPhrase('unprocessedSubmissionWithSameIsrcExists')
							});
						} else {
							errors.clear(fullPath);
						}
					}
				}))),
				Message(ctx => {
					return renderDuplicateIsrcMessage(ctx);
				}),
				Cross().setItems([
					FormItem('mainArtist', 'lookup').setIsCombo(false).setLookup(ctx => getMainArtistLookup(ctx.getRootProperty('roleInfo'))).setMaxLength(400).setMandatory(true).setFreeText(true).setNoDropDown(true),
					FormItem('album', 'text').setMaxLength(250)
				]),
				Cross().setItems([
					FormItem('title', 'text').setMandatory(true).setMaxLength(250),
					FormItem('subtitle', 'text').setMaxLength(250),
				]),
				Cross().setItems([
					FormItem('genreId', 'lookup')
						.setLookup('recordingProtocolGenre')
						.setMandatory(true)
						.onChange((ctx, def, value) => {
							const prevValue = ctx.getProperty('genreId');
							console.log(value, prevValue);
							ctx.setRootProperty(['tmp', 'perKey'], value);
							let pers = ctx.getRootProperty(['lineup', 'performers']);
							if (pers) {
								pers = pers.map(per => {
									return per.set('creatorRoleId', null);
								});
								ctx.setRootProperty(['lineup', 'performers'], pers);
							}
						}),
					FormItem('releaseYear', 'lookup').setLookup('year'),
					FormItem('productionYear', 'lookup').setLookup('year'),
					// FormItem('publicationYear', 'lookup').setLookup('year'),
					FormItem('length', 'runtime').setValidator(ContextValidator(((errors, ctx, itemName) => {
						if (itemName === 'length' || !itemName) {
							const value = ctx.getProperty('length');
							const fullPath = ctx.getFullPath('length');
							if (isEmpty(value)) {
								errors.add(
									fullPath,
									{
										type: 'error',
										code: 'mandatoryField',
										longMessage: getFormItemLabel('length', 'recording') + getPhrase('isAMandatoryField'),
										message: getPhrase('mandatoryField')
									}
								);
							} else {
								errors.clear(fullPath, 'mandatoryField');
							}
							errors.add(fullPath, {
								type: 'error',
								code: 'invalidValue',
								message: validateRuntime(value)
							});

						}
					}))),
				]).setValidator(ContextValidator(((errors, ctx, itemName) => {
					if (itemName === 'releaseYear' || itemName === 'productionYear' /*|| itemName === 'publicationYear'*/ || !itemName) {
						const fullPath = ctx.getFullPath('releaseYear');
						const aloSet = ctx.getProperty('releaseYear') || ctx.getProperty('productionYear') /*|| ctx.getProperty('publicationYear')*/;
						errors.add(fullPath, {
							type: 'error',
							code: 'invalidValue',
							message: aloSet ? null : getPhrase('releaseOrProductionYearIsMandatory')
						});
					}
				}))),
				Cross().setItems([
					FormItem('recordingCountryId', 'lookup').setLookup('country').setWidth('calc( 50% - 7px )')
				]),
				// FormItem('comments', 'text').setMultiline(true).setMaxLength(1000)
			])
		).setMargin(margin).setBoxPadding(boxPadding).setPadding(contentPadding).setHeaderPadding(headerPadding),
	]);

const ErrorMessage = styled.div`
	.header {
		font-weight: 700;
		margin: 16px;
	}

	.error {
		margin: 8px;
	}
`;

async function showErrorDialog(errorEntries) {
	let warnings = [];
	let errors = [];
	errorEntries.forEach(ee => {
		const error = ee.get('error');
		const type = error.get('type');
		const message = error.get('longMessage') || error.get('message');
		if (type === 'warning') {
			if (warnings.indexOf(message) < 0) {
				warnings.push(message);
			}
		} else {
			if (errors.indexOf(message) < 0) {
				errors.push(message);
			}
		}
	});
	if (errors.length > 0) {
		await showMessageBox(() => {
			return (
				<ErrorMessage>
					<div className='header'>{getPhrase('correctTheFollowingErrors')}:</div>
					<ul>
						{
							errors.map((error, index) => {
								return (
									<li className='error' key={index}>{error}</li>
								);
							})
						}
					</ul>
				</ErrorMessage>
			);
		});
		return false;
	}
	return true;
}

const getMainArtistLookup = memoizeOne(roleInfo => {
	roleInfo = roleInfo || EMPTY_MAP;
	return StaticLookup(roleInfo.get('relatedEnsembles') || EMPTY_LIST);
});

function getHeaderFromContext(ctx, stepId) {
	return getHeader(ctx.getRootProperty('roleInfo'), ctx.getRootProperty('status'), ctx.getRootProperty('type'), ctx.getRootProperty('requestedType'));
}

function getRequestedTypeHeaderText(requestedType, luType) {
	if (!requestedType) {
		return null;
	}
	let res = '';
	if (requestedType.indexOf('I') >= 0 || requestedType.indexOf('A') >= 0) {
		res = luType.getText('I');
	}
	if (requestedType.indexOf('K') >= 0) {
		if (res) {
			res += ' + ';
		}
		res += luType.getText('K');
	}
	return res;
}

const getHeader = memoizeOne((roleInfo, statusId, typeId, requestedType) => {
	if (!roleInfo) {
		return null;
	}
	const luType = getLookup('recordingProtocolSubmissionType');
	return (
		<ModuleHeader>
			<ModuleHeaderItem>{roleInfo.get('name')}</ModuleHeaderItem>
			<ModuleHeaderItem light>{roleInfo.get('roleTypeName')}</ModuleHeaderItem>
			{
				typeId ? (
					<ModuleHeaderItem>{luType.getText(typeId)}</ModuleHeaderItem>
				) : (
					<ModuleHeaderItem>{getRequestedTypeHeaderText(requestedType, luType)}</ModuleHeaderItem>
				)
			}
			{
				statusId && (
					<StatusBubble className={statusId}>{getLookup('recordingProtocolSubmissionStatus').getText(statusId)}</StatusBubble>
				)
			}
		</ModuleHeader>
	);
});

const PERFORMER_TOTAL_SHARE_PATH = ['lineup', 'performerTotalShare'];
const PERFORMER_INVALID_AC_ROLE_COMBINATION_PATH = ['lineup', 'invalidAcRoleCombinationPath'];

function getPerformerTabularInput(type, shareOrRole) {
	/*
                lrec.creator_role_id := ljsn.get_string('creatorRoleId');
                lrec.country_id := ljsn.get_string('countryId');
                lrec.share_pct := ljsn.get_number('sharePct');
                lrec.is_main_artist_member := ljsn.get_string('isMainArtistMember');
	*/
	let items = [
		FormItem('pinDob', 'text').setMaxLength(20).setValidator(ValueValidator(validatePinDob)).setMandatory(ctx => ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) === 'Y'),
		FormItem('firstName', 'text').setMaxLength(250).setMandatory(true),
		FormItem('lastName', 'text').setMaxLength(250).setMandatory(true),
		FormItem('businessName', 'text').setMaxLength(250).setMandatory(true).setLabel(ctx => getColumnText('name')),
		FormItem('countryId', 'lookup').setLookup('country').setMandatory(ctx => ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) === 'Y'),
		FormItem('sharePct', 'number').setWidth('120px').setMaxDecimals(4).setValidator(getRangeValidator(0, 100)).setMandatory(ctx => ctx.getRootProperty('shareOrRole') === 'S'),
		FormItem('creatorRoleId', 'lookup').setLookup(ctx => getLookup('creatorRole.PER.' + ctx.getRootProperty(['recording', 'genreId']))).setWidth('180px').setMandatory(ctx => ctx.getRootProperty('shareOrRole') === 'R'),
		FormItem('isMainArtistMember', 'lookup').setLabel(ctx => getFormItemLabel('is_ma')).setLookup('ynBoolean').setWidth('100px')
	];

	if (type === 'isrc') {
		items = items.filter(fi => fi.getName() !== 'businessName');
	} else {
		items = items.filter(fi => fi.getName() !== 'firstName' && fi.getName() !== 'lastName');
	}
	items = items.filter(fi => {
		const name = fi.getName();
		if (name === 'sharePct') {
			return shareOrRole === 'share';
		} else if (name === 'creatorRoleId') {
			return shareOrRole === 'role';
		}
		return true;
	});


	let res = TabularInput().setMainHeader(() => getPhrase('recordingProtocol.performers')).setPath(['lineup', 'performers']).setItems(items)
		.onRowChange(async (ctx, rowIndex, item) => {
			if (item.getName() === 'pinDob') {
				let pin = null;
				let dateOfBirth = null;
				const value = parsePinDob(item.getValue(ctx));
				if (value) {
					if (value.type === 'pin') {
						pin = value.value;
					} else if (value.type === 'date') {
						dateOfBirth = value.value;
					}
				}
				ctx.setProperty('pin', pin);
				ctx.setProperty('dateOfBirth', dateOfBirth);
			}
		})
		.setKeySuffix(ctx => ctx.getRootProperty(['tmp', 'perKey']))
		.onChange((ctx, rowIndex, item) => {
			// console.log(item.getName(), ctx.getProperty([rowIndex, item.getName()]), ctx.getData().toJS());
			ctx.setRootProperty(PERFORMER_TOTAL_SHARE_PATH, sum(ctx.getData(), 'sharePct'));
		})
		.setMainError(ctx => {
			const err = ctx.getRootError(PERFORMER_INVALID_AC_ROLE_COMBINATION_PATH);
			return err;
		})
		.setRowValidator(ContextValidator((errors, ctx, itemName) => {
		/*	if (!itemName || (itemName === 'share' || itemName === 'role')) {
				const path = ctx.getFullPath('role');
				const shareOrRole = ctx.getRootProperty('shareOrRole');
				if (isEmpty(ctx.getProperty('sharePct')) && isEmpty(ctx.getProperty('creatorRoleId'))) {
					errors.add(path, getPhrase('roleOrShareMandatory'), 'roleOrShareMandatory');
				} else {
					errors.clear(path, 'roleOrShareMandatory');
				}
			}*/
		}))
		.setRowListValidator(ContextValidator((errors, ctx, itemName) => {
			// jsme zavisli na zmenach udelanych v onChange, takze aktualizujeme context, aby videl provedene zmeny
			ctx.updateData(true);
			const path = PERFORMER_TOTAL_SHARE_PATH;
			const totalShare = ctx.getRootProperty(path);
			const cmp = typeof totalShare === 'number' ? compareShares(100, totalShare) : null;
			errors.add(path, ctx.getRootProperty('shareOrRole') === 'S' && cmp ? getPhrase('totalShareMustBe100') : null, 'totalShare');
			if (!itemName) {
				const rows = ctx.getData();
				errors.add(['detail', 'aloPerformer'], !rows || rows.filter(r => !r.get('_deleted')).size === 0 ? getPhrase('recordingProtocol.aloPerormer') : null, 'aloPerformer');
			}
			const rows = ctx.getData();
			let hasA = false, hasB = false, hasC = false;
			if (rows && shareOrRole === 'role') {
				rows.forEach(row => {
					const creatorRoleId = row.get('creatorRoleId');
					if (creatorRoleId === 'A') {
						hasA = true;
					} else if (creatorRoleId === 'B') {
						hasB = true;
					} else if (creatorRoleId === 'C') {
						hasC = true;
					}
				});
			}
			if (hasA && hasC && !hasB) {
				errors.add(PERFORMER_INVALID_AC_ROLE_COMBINATION_PATH, getPhrase('recordingProtocol.invalidACRoleCombination'));
			} else {
				errors.clear(PERFORMER_INVALID_AC_ROLE_COMBINATION_PATH);
			}
		}));

	return res;
}

function processLineupForSave(ctx, lineup) {
	let authors = [];
	let performers = [];
	let res = {
		performers,
		authors
	};
	const shareOrRole = ctx.getRootProperty('shareOrRole');
	(lineup.performers || []).forEach(p => {
		p = Object.assign({}, p);
		performers.push(p);
		if (shareOrRole === 'S') {
			p.creatorRoleId = null;
		} else if (shareOrRole === 'R') {
			p.sharePct = null;
		} else {
			p.creatorRoleId = null;
			p.sharePct = null;
		}
	});
	(lineup.composers || []).forEach(a => {
		a = Object.assign({creatorRoleId: 'AH'}, a);
		authors.push(a);
	});
	(lineup.lyricists || []).forEach(a => {
		a = Object.assign({creatorRoleId: 'AT'}, a);
		authors.push(a);
	});
	return res;
}

function isReducedRelevance(ctx) {
	const recording = ctx.getRootProperty('recording') || EMPTY_MAP;
	const noIsrc = isEmpty(recording.get('isrc'));
	const lineupFinal = recording.get('isPerformerLineupFinal') === 'Y';
	const isPerformer = ctx.getRootProperty(['roleInfo', 'roleTypeId']) === 'PER';
	return noIsrc || !lineupFinal || isPerformer;
}

async function saveRecordingProtocol(ctx) {
	const roleInfo = ctx.getRootProperty('roleInfo');
	console.log(ctx.getData().toJS());
	let pars = {
		recording: ctx.getRootProperty('recording').toJS(),
		lineup: processLineupForSave(ctx, ctx.getRootProperty('lineup').toJS()),
		partyId: roleInfo.get('partyId'),
		roleTypeId: roleInfo.get('roleTypeId'),
		type: ctx.getRootProperty('type')
	};
	if (pars.type) {
		if (pars.type === 'A') {
			if (!isReducedRelevance(ctx)) {
				pars.type = 'I';
			}
		} else if (pars.type === 'I') {
			if (isReducedRelevance(ctx)) {
				pars.type = 'A';
			}
		}
	} else {
		pars.type = ctx.getRootProperty('requestedType');
		if (pars.type) {
			if (isReducedRelevance(ctx)) {
				pars.type = pars.type.replace('I', 'A');
			}
		}
	}
	// console.log(pars);
	let res = webapi.execute('/api/proc/api_myrecordings/saveRecordingProtocol', pars);
	if (res !== REPORTED_EXCEPTION) {
		ctx.setRootProperty('originalRecording', ctx.getRootProperty('recording'));
		ctx.setRootProperty('originalLineup', ctx.getRootProperty('lineup'));
		updateEntityTimestamp('recordingProtocol');
	}
	return res;
}

function normalizeShareOrRole(ctx) {
	const ipf = ctx.getRootProperty(['recording', 'isPerformerLineupFinal']);
	const sor = ctx.getRootProperty('shareOrRole');
	const performers = ctx.getRootProperty(['lineup', 'performers']);
	if (performers && (sor === 'N' || !sor)) {
		if (performers.some(p => p.get('sharePct'))) {
			ctx.setProperty('shareOrRole', 'S');
			return;
		} else if (performers.some(p => p.get('creatorRoleId'))) {
			ctx.setProperty('shareOrRole', 'R');
			return;
		}
	}
	if ((ipf === 'Y' && sor === 'N') || !sor) {
		ctx.setRootProperty('shareOrRole', 'S');
	}
}

function isAuthorEmpty(row) {
	return !(row.get('pinDob') || row.get('firstName') || row.get('lastName'));
}

function isAuthorEmptyOrDeleted(row) {
	if (row.get('_deleted')) {
		return true;
	}
	return isAuthorEmpty(row);
}

const lineupFormDefinition = Form().setItems([
	Box().setContent(
		Container([
			Message(ctx => {
				return renderDuplicateIsrcMessage(ctx);
			}),
			Cross().setItems([
				FormItem('isPerformerLineupFinal', 'lookup')
					.setLookup('ynBoolean')
					.setPath(['recording', 'isPerformerLineupFinal'])
					.setWidth('220px')
					.setMargin('0px 0px 8px 0px')
					.setMandatory(true)
					.onChange((ctx, def, value) => {
						normalizeShareOrRole(ctx);
						processPerformerNames(ctx);
					}),
				FormItem('shareOrRole', 'lookup').setLookup(ctx => {
					if (ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) === 'N') {
						return getLookup('shareOrRoleOrNothing');
					} else {
						return getLookup('shareOrRole');
					}
				}).setWidth('160px').setMandatory(true).setMargin('0px 0px 8px 8px')
			]).setAlignItems('flex-end'),
			getPerformerTabularInput('isrc', 'share').setVisible(ctx => ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) !== 'N' && ctx.getRootProperty('shareOrRole') === 'S'),
			getPerformerTabularInput('album', 'share').setVisible(ctx => ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) === 'N' && ctx.getRootProperty('shareOrRole') === 'S'),
			getPerformerTabularInput('isrc', 'role').setVisible(ctx => ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) !== 'N' && ctx.getRootProperty('shareOrRole') === 'R'),
			getPerformerTabularInput('album', 'role').setVisible(ctx => ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) === 'N' && ctx.getRootProperty('shareOrRole') === 'R'),
			getPerformerTabularInput('album', 'neither').setVisible(ctx => ctx.getRootProperty(['recording', 'isPerformerLineupFinal']) === 'N' && ctx.getRootProperty('shareOrRole') === 'N'),
			Cross().setItems([
				FormItem('performerTotalShare', 'number').setReadOnly(true).setWidth('200px').setPath(PERFORMER_TOTAL_SHARE_PATH)
			]).setJustifyContent('right').setVisible(ctx => ctx.getRootProperty('shareOrRole') === 'S'),
			Cross().setItems([
				TabularInput().setMarginTop('32px').setMainHeader(() => getPhrase('recordingProtocol.composers')).setPath(['lineup', 'composers']).setItems([
					// FormItem('role', 'lookup').setLookup('recordingProtocolAuthorRole').setWidth('180px'),
					FormItem('pinDob', 'text').setMaxLength(20).setValidator(ValueValidator(validatePinDob)).setWidth('140px'),
					// FormItem('title', 'text').setWidth('120px').setMaxLength(30).setLabel(getColumnText('title', 'party')),
					FormItem('firstName', 'text').setMaxLength(255),
					FormItem('lastName', 'text').setMaxLength(255),
					// FormItem('suffix', 'text').setWidth('120px').setMaxLength(30).setLabel(getColumnText('suffix', 'party')),
				]).onRowChange(async (ctx, rowIndex, item) => {
					if (item.getName() === 'pinDob') {
						let pin = null;
						let dateOfBirth = null;
						const value = parsePinDob(item.getValue(ctx));
						if (value) {
							if (value.type === 'pin') {
								pin = value.value;
							} else if (value.type === 'date') {
								dateOfBirth = value.value;
							}
						}
						ctx.setProperty('pin', pin);
						ctx.setProperty('dateOfBirth', dateOfBirth);
					}
				}).setRowValidator(ContextValidator((errors, ctx, itemName) => {
					const path = ctx.getFullPath('lastName');
					ctx.updateData(true);
					const row = ctx.getData();
					if (isAuthorEmptyOrDeleted(row)) {
						errors.clear(path, 'mandatory');
					} else {
						const lastName = row.get('lastName');
						if ((!itemName && isEmpty(lastName)) || lastName === '') {
							errors.add(path, {
								type: 'error',
								message: getPhrase('mandatoryField'),
								longMessage: getFormItemLabel('lastName') + getPhrase('isAMandatoryField')
							}, 'mandatory');
						} else {
							errors.clear(path, 'mandatory');
						}
					}
				})).setMainError(ctx => {
					const genreId = ctx.getRootProperty(['recording', 'genreId']);
					if (genreId !== 'CLS') {
						return null;
					}
					const composers = ctx.getRootProperty(['lineup', 'composers']);
					if (hasComposer(composers)) {
						return null;
					}
					return getPhrase('recordingProtocolCLSMissingComposer');
				}),
				TabularInput().setMarginTop('32px').setMainHeader(() => getPhrase('recordingProtocol.lyricists')).setPath(['lineup', 'lyricists']).setItems([
					// FormItem('role', 'lookup').setLookup('recordingProtocolAuthorRole').setWidth('180px'),
					FormItem('pinDob', 'text').setMaxLength(20).setValidator(ValueValidator(validatePinDob)).setWidth('140px'),
					// FormItem('title', 'text').setWidth('120px').setMaxLength(30).setLabel(getColumnText('title', 'party')),
					FormItem('firstName', 'text').setMaxLength(255),
					FormItem('lastName', 'text').setMaxLength(255),
					// FormItem('suffix', 'text').setWidth('120px').setMaxLength(30).setLabel(getColumnText('suffix', 'party')),
				]).setRowValidator(ContextValidator((errors, ctx, itemName) => {
					const path = ctx.getFullPath('lastName');
					ctx.updateData(true);
					const row = ctx.getData();
					if (isAuthorEmptyOrDeleted(row)) {
						errors.clear(path, 'mandatory');
					} else {
						const lastName = row.get('lastName');
						if ((!itemName && isEmpty(lastName)) || lastName === '') {
							errors.add(path, {
								type: 'error',
								message: getPhrase('mandatoryField'),
								longMessage: getFormItemLabel('lastName') + getPhrase('isAMandatoryField')
							}, 'mandatory');
						} else {
							errors.clear(path, 'mandatory');
						}
					}
				})).onRowChange(async (ctx, rowIndex, item) => {
					if (item.getName() === 'pinDob') {
						let pin = null;
						let dateOfBirth = null;
						const value = parsePinDob(item.getValue(ctx));
						if (value) {
							if (value.type === 'pin') {
								pin = value.value;
							} else if (value.type === 'date') {
								dateOfBirth = value.value;
							}
						}
						ctx.setProperty('pin', pin);
						ctx.setProperty('dateOfBirth', dateOfBirth);
					}
				}),

			]),
			/*Message(ctx => {
				const genreId = ctx.getRootProperty(['recording', 'genreId']);
				if (genreId !== 'CLS') {
					return null;
				}
				const composers = ctx.getRootProperty(['lineup', 'composers']);
				if (hasComposer(composers)) {
					return null;
				}
				return (
					<Error
						error={getPhrase('recordingProtocolCLSMissingComposer')}
					/>
				);
			}),*/
		])
	).setMargin(margin).setBoxPadding(boxPadding).setPadding(contentPadding).setHeaderPadding(headerPadding),
]);

const hasComposer = memoizeOne(composers => {
	return composers && composers.some(c => !isAuthorEmptyOrDeleted(c));
});

let wizardDefinition = Wizard().setSelectedStepIdPath(['selectedStepId']).setSteps([
	Step('protocolTypeSelection')
		.setContent(Centerer(
			Form().setItems([
				FormItem('roleId', 'lookup').setLookup('recordingProtocolPartyRole').setMandatory(true).setLabel(ctx => getFormItemLabel('submissionOnBehalfOf')),
				Message(ctx => {
					const isProducer = (ctx.getProperty('roleId') || '').endsWith('PRO');
					return (
						<ProtocolTypeWrapper>
							{
								protocolTypeKeys.map((ptk, index) => {
									if (!isProducer && ptk.code !== 'I') {
										return null;
									}
									return (
										<ProtocolType key={index}>
											<a className="header" onClick={async e => {
												e.preventDefault();
												const res = await webapi.execute('/api/proc/api_myrecordings/getRecordingProtocolRoleInfo', {
													roleId: ctx.getProperty('roleId')
												});
												if (res === REPORTED_EXCEPTION) {
													return;
												}
												ctx.setProperty('roleInfo', Immutable.fromJS(res));
												ctx.setProperty('requestedType', ptk.code);
												if (res.roleTypeId === 'PRO') {
													ctx.setProperty(['recording', 'producer'], res.name);
												}
												ctx.setProperty('selectedStepId', 'basicInfo');
											}}>{getPhrase(ptk.phraseId)}</a>
											<div className="text">{getPhrase(ptk.phraseId + 'Hint')}</div>
										</ProtocolType>
									);
								})
							}
						</ProtocolTypeWrapper>
					);
				}),
			])
		).setWidth('600px')),
	Step('basicInfo')
		// .setHeader(getPhrase('basicInfo'))
		.setHeader(ctx => getHeaderFromContext(ctx, 'basicInfo'))
		.setNextButtonText(() => getPhrase('proceedToLineupEntry'))
		.setNextButtonAction(async ctx => {
			const hasIsrc = !isEmpty(ctx.getRootProperty(['recording', 'isrc']));
			if (!ctx.getRootProperty(['recording', 'isPerformerLineupFinal'])) {
				ctx.setRootProperty(['recording', 'isPerformerLineupFinal'], hasIsrc ? 'Y' : 'N');
			}
			normalizeShareOrRole(ctx);


			await processIsrcChange(ctx, ctx.getRootProperty(['recording', 'isrc']));

			const errors = DefinitionUtils.validateAll(ctx, basicInfoFormDefinition);

			ctx.setRootErrors(errors.mergeWith(ctx.getRootErrors()));
			const errorEntries = errors.getErrorEntries();
			// console.log(errorEntries.toJS());
			if (errorEntries.size > 0) {
				const res = await showErrorDialog(errorEntries);
				if (!res) {
					return null;
				}
			}
			if (!hasIsrc) {
				const dlgRes = await showMessageBox(getPhrase('reallyProceedToLineupNoIsrc'), {
					type: 'confirm'
				});
				if (dlgRes !== 'yes') {
					return null;
				}
			}
			return 'lineup';
		})
		.setContent(Centerer(
			basicInfoFormDefinition
		).setWidth('100%')),
	Step('lineup')
		// .setHeader(getPhrase('lineup'))
		.setHeader(ctx => getHeaderFromContext(ctx, 'lineup'))
		.setPrevButtonText(() => getPhrase('backToBasicInfo'))
		.setPrevButtonAction(ctx => 'basicInfo')
		.setNextButtonText(() => getPhrase('proceedToRecordingProtocolSummary'))
		.setNextButtonAction(async ctx => {
			const errors = DefinitionUtils.validateAll(ctx, lineupFormDefinition);

			ctx.setRootErrors(errors.mergeWith(ctx.getRootErrors()));
			const errorEntries = errors.getErrorEntries();
			// console.log(errorEntries.toJS());
			if (errorEntries.size > 0) {
				const res = await showErrorDialog(errorEntries);
				if (!res) {
					return null;
				}
			}
			normalizePerformerNames(ctx);
			normalizeAuthors(ctx);
			return 'recordingProtocolSummary';
		})
		.setContent(Centerer(
			lineupFormDefinition
		).setWidth('100%')),
	Step('recordingProtocolSummary')
		// .setHeader(getPhrase('recordingProtocolSummary'))
		.setHeader(ctx => getHeaderFromContext(ctx, 'recordingProtocolSummary'))
		.setPrevButtonAction(ctx => 'lineup')
		.setPrevButtonText(ctx => {
			if (ctx.getRootProperty('readOnly')) {
				return null;
			}
			return getPhrase('backToLineup');
		})
		.setNextButtonAction(async ctx => {
			const res = await saveRecordingProtocol(ctx);
			if (res === REPORTED_EXCEPTION) {
				return;
			}
			return 'result';
		})
		.setNextButtonText(ctx => {
			if (ctx.getRootProperty('readOnly')) {
				return null;
			}
			if (needsDeclaration(ctx) && !ctx.getRootProperty('declarationChecked')) {
				return null;
			}
			return getPhrase('submitRecordingProtocol');
		})
		.setContent(Centerer(
			Message(ctx => {
				const adminMode = ctx.getRootProperty('adminMode');
				const recording = ctx.getRootProperty('recording') || EMPTY_MAP;
				const lineup = ctx.getRootProperty('lineup') || EMPTY_MAP;
				const performers = (lineup.get('performers') || EMPTY_LIST).filter(c => !c.get('_deleted'));
				const composers = (lineup.get('composers') || EMPTY_LIST).filter(c => !c.get('_deleted'));
				const lyricists = (lineup.get('lyricists') || EMPTY_LIST).filter(c => !c.get('_deleted'));
				const statusId = ctx.getRootProperty('status');
				const adminSameIsrc = ctx.getRootProperty('adminSameIsrc');
				let itgComments = statusId && statusId !== 'SUBMITTED' && statusId !== 'RETURNED' ? ctx.getRootProperty('comments') : null;
				return (
					<Summary>
						{
							renderDuplicateIsrcMessage(ctx)
						}
						{
							adminSameIsrc && (
								<PortalMessage>
									<IsrcWarnings>
										<div className='header'>{getPhrase('mdb.adminSameIsrcRecordingWarningHeader')}</div>
										<div className='body'>
											{
												adminSameIsrc.map((w, index) => {
													return (
														<div className='adminMdbWarning'>
															{
																['recordingId', 'title', 'subtitle', 'productionYear', 'releaseYear'].map(attr => {
																	let value = w.get(attr);
																	if (!value) {
																		return null;
																	}
																	return (
																		<span className='attribute'>
																			<span className='label'>{getFormItemLabel(attr)}:</span>
																			<span className='value'>{value}</span>
																		</span>
																	);
																})
															}
														</div>
													);
												})
											}
										</div>
									</IsrcWarnings>
								</PortalMessage>
							)
						}
						{
							itgComments && (
								<PortalMessage>
									{
										itgComments.replace(/#[a-zA-Z0-9_]*/g, (token) => {
											const phraseId = 'recordingProtocolMessage' + token;
											// console.log(phraseId, token);
											return getPhrase(phraseId);
										})
									}
								</PortalMessage>
							)
						}
						<BoxComponent header={getPhrase('basicInfo')} className="section">
							<table className='attributes'>
								<tbody>
									{
										recordingAttributes.map(attr => {
											let value = recording.get(attr);
											if (attr === 'length') {
												value = RuntimeUtils.formatRuntime(value);
											} else if (attr === 'genreId') {
												value = getLookup('recordingProtocolGenre').getText(value);
											} else if (attr === 'recordingCountryId') {
												value = getLookup('country').getText(value);
											} else if (attr === 'recordingTypeId') {
												value = getLookup('recordingProtocolRecordingType').getText(value);
											}
											return (
												<tr key={attr}>
													<td className='label'>{getFormItemLabel(attr, 'recordingProtocol')}:</td>
													<td className='value'>{value}</td>
												</tr>
											);
										})
									}

								</tbody>
							</table>
						</BoxComponent>
						<BoxComponent header={getPhrase('recordingProtocol.performers')} className="section">
							<table className='creators'>
								<tbody>
									{
										performers.map((per, index) => {
											return (
												<tr key={index}>
													<td>
														{renderSummaryCreator(per)}
													</td>
												</tr>
											);
										})
									}
								</tbody>
							</table>
						</BoxComponent>
						{
							composers.size > 0 && (
								<BoxComponent header={getPhrase('recordingProtocol.composers')} className="section">
									<table className='creators'>
										<tbody>
											{
												composers.map((per, index) => {
													return (
														<tr key={index}>
															<td>
																{renderSummaryCreator(per)}
															</td>
														</tr>
													);
												})
											}
										</tbody>
									</table>
								</BoxComponent>
							)
						}
						{
							lyricists.size > 0 && (
								<BoxComponent header={getPhrase('recordingProtocol.lyricists')} className="section">
									<table className='creators'>
										<tbody>
											{
												lyricists.map((per, index) => {
													return (
														<tr key={index}>
															<td>
																{renderSummaryCreator(per)}
															</td>
														</tr>
													);
												})
											}
										</tbody>
									</table>
								</BoxComponent>
							)
						}
						{!adminMode && renderDeclaration(ctx)}
						{ctx.getRootProperty('readOnly') && !adminMode && renderCopyButtons(ctx, 'summary')}
						{
							adminMode && statusId === 'SUBMITTED' && (
								<AdminButtons>
									{
										adminButtons.map(type => {
											return (
												<Button
													text={getPhrase(type)}
													className={type}
													key={type}
													negative={type !== 'approve'}
													onAction={() => {
														executeAdminAction(ctx, type);
													}}
												/>
											);
										})
									}
								</AdminButtons>
							)
						}
					</Summary>
				);
			})
		)),
	Step('result')
		// .setHeader(getPhrase('recordingProtocolSummary'))
		.setHeader(ctx => getHeaderFromContext(ctx, 'result'))
		.setContent(Centerer(
			Message(ctx => {
				return (
					<ResultPane>
						{renderCopyButtons(ctx, 'result')}
					</ResultPane>
				);
			})
		))
]);

async function executeAdminAction(ctx, type) {
	let comments;
	if (type === 'approve') {
		const dlgRes = await showMessageBox(getPhrase('reallyApproveRecordingProtocol'), {
			type: 'confirm'
		});
		if (dlgRes !== 'yes') {
			return;
		}
	} else {
		comments = await showMessageBox(getPhrase('recordingProtocolAdminStatusComments.' + type), {
			type: 'input',
			multiline: true
		});
		if (!comments) {
			return;
		}
	}
	const statusId = type === 'approve' ? 'IN_PROGRESS' : type === 'deny' ? 'DENIED' : 'RETURNED';
	const res = await webapi.execute('/api/proc/api_myrecordings/setRecordingProtocolStatus', {
		recordingProtocolId: ctx.getRootProperty(['recording', 'recordingProtocolId']),
		statusId,
		comments
	});
	if (res === REPORTED_EXCEPTION) {
		return;
	}
	ctx.setRootProperty('status', statusId);
	updateEntityTimestamp('recordingProtocol');
}

const adminButtons = [
	'approve',
	'return',
	'deny'
];

const AdminButtons = styled.div`
	text-align: center;
	.ps-button {
		margin: 16px 32px;
	}
`;

const CopyButton = styled.div`
	padding: 16px;
	background: #FFFFFF;
	box-shadow: 7px 13px 80px rgba(21, 46, 67, 0.1);
	border-radius: 15px;

	a.header {
		color: ${props => props.theme.textColor};
		//font-weight: 500;
		text-decoration: none;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
		font-size: 18px;
		margin-bottom: 8px;
		display: inline-block;
	}

	.text {
		font-size: 16px;
		color: ${props => props.theme.disabledTextColor};
	}

`;

const CopyButtons = styled.div`
	margin: 16px;
	margin-top: 64px;

	&.summary {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
		grid-gap: 16px;
	}

	&.result {
		${CopyButton} {
			margin-top: 16px;
		}
	}

`;

const copyButtons = [
	'exact',
	'album',
	'video',
	'empty'
];

function clearLineupId(ctx, type) {
	const creators = ctx.getRootProperty(['lineup', type]);
	if (!creators) {
		return;
	}
	ctx.setRootProperty(['lineup', type], creators.map(c => c.delete('recordingProtocolLineupId')));
}

function getOriginalRequestedType(ctx) {
	return (ctx.getRootProperty('requestedType') || ctx.getRootProperty('type') || 'I').replace('A', 'I');
}

async function copy(ctx, type) {
	// console.log('type', type);
	const requestedType = getOriginalRequestedType(ctx);
	console.log(requestedType);
	ctx.setRootProperty('type', null);
	ctx.setRootProperty('requestedType', requestedType);
	ctx.setRootProperty('readOnly', false);
	ctx.setRootProperty('status', null);
	ctx.setRootProperty(['recording', 'recordingProtocolId'], null);
	clearLineupId(ctx, 'performers');
	clearLineupId(ctx, 'lyricists');
	clearLineupId(ctx, 'composers');
	if (type === 'album') {
		ctx.setRootProperty(['recording', 'isrc'], '');
		ctx.setRootProperty(['recording', 'title'], '');
		ctx.setRootProperty(['recording', 'subtitle'], '');
		ctx.setRootProperty(['recording', 'length'], null);
	} else if (type === 'video') {
		ctx.setRootProperty(['recording', 'isrc'], '');
		ctx.setRootProperty(['recording', 'recordingTypeId'], 'V');
		const producerCodes = ctx.getRootProperty(['roleInfo', 'producerCodes', 'V']) || EMPTY_LIST;
		if (!processRecordingTypeChange(ctx)) {
			ctx.setRootProperty(['recording', 'isrc'], '');
		}
	} else if (type === 'empty') {
		ctx.setRootProperty('recording', EMPTY_MAP);
		ctx.setRootProperty('lineup', EMPTY_MAP);
		ctx.setRootProperty('tmp', EMPTY_MAP);
	}
	ctx.setRootProperty('declarationChecked', false);
	ctx.setRootProperty('selectedStepId', 'basicInfo');
	await processIsrcChange(ctx, ctx.getRootProperty(['recording', 'isrc']));
}

function renderCopyButtons(ctx, type) {
	const recordingTypeId = ctx.getRootProperty(['recording', 'recordingTypeId']);
	return (
		<CopyButtons className={type}>
			{
				copyButtons.map(cb => {
					if (recordingTypeId === 'V' && cb === 'video') {
						return null;
					} else if (cb === 'empty' && type !== 'result') {
						return null;
					}
					return (
						<CopyButton key={cb}>
							<a
								className='header'
								onMouseDown={async e => {
									e.preventDefault();
									copy(ctx, cb);
								}}
							>{getPhrase('recordingProtocolCopyButtonHeader.' + cb)}</a>
							<div className='text'>
								{getPhrase('recordingProtocolCopyButtonText.' + cb)}
							</div>
						</CopyButton>
					);
				})
			}
		</CopyButtons>
	);
}

const ResultPane = styled.div`
	width: 740px;
`;

const summaryCreatorAttributes = [
	'dateOfBirth',
	'pin',
	'countryId',
	'sharePct',
	'creatorRoleId',
	'isMainArtistMember',
];

function needsDeclaration(ctx) {
	if (ctx.getRootProperty('readOnly')) {
		return false;
	}
	if (ctx.getRootProperty('requestedType') === 'K') {
		return false;
	}
	return true;
}

function renderDeclaration(ctx) {
	if (!needsDeclaration(ctx)) {
		return null;
	}
	const roleInfo = ctx.getRootProperty('roleInfo');
	if (!roleInfo) {
		return null;
	}
	const roleTypeId = roleInfo.get('roleTypeId');
	// const roleTypeId = 'PER';
	const checked = ctx.getRootProperty('declarationChecked');
	return (
		<Declaration>
			<a
				className='header'
				onMouseDown={e => {
					e.preventDefault();
					ctx.setRootProperty('declarationChecked', !checked);
				}}
			>
				<Icon
					name={checked ? 'checkBoxChecked' : 'checkBoxUnchecked'}
				/>
				{getPhrase('recordingProtocolDeclaration.' + roleTypeId)}
			</a>
			{
				roleTypeId === 'PER' && (
					<div className='text'>{getPhrase('recordingProtocolDeclaration.' + roleTypeId + '.hint')}</div>
				)
			}
		</Declaration>
	);
}

function deleteEmptyAuthors(rows) {
	if (!rows) {
		return rows;
	}
	return rows.map(row => {
		if (!row.get('_deleted') && isAuthorEmpty(row)) {
			return row.set('_deleted', true);
		} else {
			return row;
		}
	});
}

function normalizeAuthors(ctx) {
	ctx.setRootProperty(['lineup', 'composers'], deleteEmptyAuthors(ctx.getRootProperty(['lineup', 'composers'])));
	ctx.setRootProperty(['lineup', 'lyricists'], deleteEmptyAuthors(ctx.getRootProperty(['lineup', 'lyricists'])));
}

function normalizePerformerNames(ctx) {
	const performers = ctx.getRootProperty(['lineup', 'performers']);
	if (!performers) {
		return;
	}
	let modPerformers = performers;
	const ipf = ctx.getRootProperty(['recording', 'isPerformerLineupFinal']);
	if (ipf === 'N') {
		modPerformers = modPerformers.map(p => {
			return p.delete('lastName').delete('firstName');
		});
	} else {
		modPerformers = modPerformers.map(p => {
			return p.delete('businessName');
		});
	}
	if (modPerformers !== performers) {
		ctx.setRootProperty(['lineup', 'performers'], modPerformers);
	}
}

function processPerformerNames(ctx) {
	const performers = ctx.getRootProperty(['lineup', 'performers']);
	if (!performers) {
		return;
	}
	let modPerformers = performers;
	const ipf = ctx.getRootProperty(['recording', 'isPerformerLineupFinal']);
	if (ipf === 'N') {
		modPerformers = modPerformers.map(p => {
			if (p.get('_deleted')) {
				return p;
			}
			const businessName = p.get('businessName');
			if (businessName) {
				return p;
			}
			const lastName = p.get('lastName');
			const firstName = p.get('firstName');
			if (lastName || firstName) {
				return p.set('businessName', ((firstName || '') + ' ' + (lastName || '')).trim());
			}
			return p;
		});
	} else {
		modPerformers = modPerformers.map(p => {
			if (p.get('_deleted')) {
				return p;
			}
			let lastName = p.get('lastName');
			let firstName = p.get('firstName');
			if (lastName || firstName) {
				return p;
			}
			const businessName = p.get('businessName');
			if (businessName) {
				let tokens = businessName.split(/\s/g);
				if (tokens.length == 2) {
					firstName = tokens[0];
					lastName = tokens[1];
				} else if (tokens.length == 1) {
					lastName = tokens[0];
				} else {
					firstName = tokens[0];
					lastName = tokens.slice(1).join(' ');
				}
				return p.set('firstName', firstName || '').set('lastName', lastName || '');
			}
			return p;
		});
	}
	if (modPerformers !== performers) {
		ctx.setRootProperty(['lineup', 'performers'], modPerformers);
	}
}


export function isRecordingProtocolDetailReadOnly(data) {
	if (!data) {
		return true;
	}
	return data.getIn(['wizard', 'data', 'readOnly']);
}

export function getRecordingProtocolInfo(data) {
	let res = {};
	if (!data) {
		return res;
	}
	const recording = data.getIn(['wizard', 'data', 'recording']);
	if (recording) {
		res.recordingProtocolId = recording.get('recordingProtocolId');
		res.title = recording.get('title');
		res.isrc = recording.get('isrc');
	}
	return res;
}

export function getRecordingProtocolInfoFromAppState(appState) {
	if (!appState) {
		return {};
	}
	return getRecordingProtocolInfo(appState.get('data'));
}

export function isRecordingProtocolModified(data) {
	const recording = data.getIn(['wizard', 'data', 'recording']);
	const lineup = data.getIn(['wizard', 'data', 'lineup']);
	const originalRecording = data.getIn(['wizard', 'data', 'originalRecording']);
	const originalLineup = data.getIn(['wizard', 'data', 'originalLineup']);
	return recording !== originalRecording || lineup !== originalLineup;
}

export function isRecordingProtocolModifiedFromAppState(appState) {
	if (!appState) {
		return false;
	}
	return isRecordingProtocolModified(appState.get('data'));
}

function renderSummaryCreator(cr) {
	const firstName = cr.get('firstName') || '';
	const lastName = cr.get('lastName') || '';
	const businessName = cr.get('businessName') || '';
	let detail = summaryCreatorAttributes.map(attr => {
		let value = cr.get(attr);
		if (!value) {
			return null;
		}
		if (attr === 'sharePct') {
			value = NumberUtils.formatNumber(value) + '%';
		} else if (attr === 'dateOfBirth') {
			value = DateUtils.formatDate(value);
		} else if (attr === 'creatorRoleId') {
			let fv = getLookup('creatorRole.PER.POP').getText(value);
			if (!fv) {
				fv = getLookup('creatorRole.PER.CLS').getText(value);
			}
			value = fv;
		} else if (attr === 'countryId') {
			value = getLookup('country').getText(value);
		} else if (attr === 'isMainArtistMember') {
			value = getLookup('ynBoolean').getText(value);
		}
		return (
			<span className='detailAttribute' key={attr}>
				<span className='label'>{getFormItemLabel(attr, 'recordingProtocol')}:</span>
				<span className='value'>{value}</span>
			</span>
		);
	}).filter(Boolean);
	return (
		<div className='creator'>
			<div className='name'>{businessName || (firstName + ' ' + lastName).trim()}</div>
			{
				detail.length > 0 && (
					<div className='detail'>{detail}</div>
				)
			}
		</div>
	);
}

const Declaration = styled.div`
	background: #FFFFFF;
	border-radius: 16px !important;
	margin: 16px;
	margin-top: 32px;
	padding: 16px;
	border: ${props => props.theme.inputBorder};
	padding-bottom: 12px;
	> div:first-child {
		background: transparent !important;
	}

	.icon {
		position: relative;
		margin-right: 8px;
		top: -2px;
		font-size: 12px;
	}

	a.header {
		color: ${props => props.theme.textColor};
		text-decoration: none;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
		font-size: 14px;
		margin-bottom: 8px;
		margin-top: 8px;
		display: block;
		font-weight: 500;
	}

	.text {
		font-size: 14px;
		color: ${props => props.theme.disabledTextColor};
		text-align: justify;
	}

`;


const Summary = styled.div`
	width: 740px;
	position: relative;
	color: ${props => props.theme.disabledTextColor};
	.section {
		border-radius: 16px !important;
		margin: 16px;
		box-shadow: 7px 13px 80px rgba(21, 46, 67, 0.1);
	//	border: ${props => props.theme.inputBorder};
		padding-bottom: 12px;
		> div:first-child {
			background: transparent !important;
		}
	}
	table {
		width: 100%;
		border-collapse: collapse;
		tr {
			&:hover {
				background: ${props => props.theme.tableRowHoverBackground};
			}
			td {
				padding: 8px 16px;
				&.label {
					font-weight: 500;
					width: 200px;
					font-size: 14px;
				}
				&.value {
					opacity: 1;
					font-size: 16px;
					color: ${props => props.theme.textColor};
				}
			}
		}
	}

	.creator {
		.name {
			color: ${props => props.theme.textColor};
		}
		.detail {
			padding: 4px 0px;
			font-size: 12px;
			.detailAttribute {
				&:not(:last-child) {
					margin-right: 8px;
				}

				.label {
					font-weight: 500;
					font-size: 12px;
					margin-right: 4px;
				}
				.value {
					font-size: 14px;
				}
			}
		}
	}
`;

const recordingAttributes = [
	'recordingTypeId',
	'isrc',
	'producer',
	'mainArtist',
	'album',
	'title',
	'subtitle',
	'genreId',
	'releaseYear',
	'productionYear',
	'length',
	'recordingCountryId',
];
